function eliminatedFeaturesForSelection(deadEnds, featureName, value) {
    const eliminated = [];
    for (const deadEnd of deadEnds || []) {
        if (deadEnd.selectedFeatureName !== featureName || deadEnd.selectedValue !== value) continue;
        if (deadEnd.eliminatedFeatureName && !eliminated.includes(deadEnd.eliminatedFeatureName)) {
            eliminated.push(deadEnd.eliminatedFeatureName);
        }
    }
    return eliminated;
}

function joinFeatureNames(names) {
    if (names.length <= 1) return names[0] || '';
    return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

export function describeWipedFeatures(value, featureNames) {
    const eliminated = [];
    for (const name of featureNames || []) {
        if (name && !eliminated.includes(name)) eliminated.push(name);
    }
    if (eliminated.length === 0) return '';
    const shown = eliminated.slice(0, 3);
    const rest = eliminated.length - shown.length;
    const list = rest > 0
        ? `${shown.join(', ')}, and ${rest} more`
        : joinFeatureNames(shown);
    const featureWord = eliminated.length === 1 ? 'feature' : 'features';
    return `Selecting ${value} blocks selection for ${featureWord} ${list}.`;
}

export function describeBlockedSelection(deadEnds, featureName, value) {
    return describeWipedFeatures(value, eliminatedFeaturesForSelection(deadEnds, featureName, value));
}
